import { ChevronDown, ChevronUp } from "lucide-react";

interface CollapsibleProps {
  title: string;
  isExpanded: boolean;
  onClick: () => void;
}

export const Collapsible: React.FC<CollapsibleProps> = ({ title, isExpanded, onClick }) => {
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={`
      flex flex-row items-center justify-center
      cursor-pointer w-fit text-neutral-800
      select-none whitespace-nowrap rounded-[5px]
      gap-1 px-[10px] py-[2px] text-[14px] font-normal border-[0.5px]
        ${isExpanded ? "border-[#aba88bcc]" : "border-neutral-300"} 
        ${isExpanded ? "bg-[#f1f1f1]" : "bg-transparent"}
      `}
    >
      {title}
      {isExpanded ? <ChevronUp width={15} color="gray" /> : <ChevronDown width={15} color="gray" />}
    </div>
  );
};
